//const API_BASE_URL = 'https://fibretelecom.peachpreview.co.uk/api';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

class MobileService {
  async createMobileService(data) {
  try {
    const response = await fetch(`${API_BASE_URL}/mobile-details`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
         'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      },
      body: JSON.stringify(data),
    });

    const result = await response.json();
    if (!response.ok) throw new Error(result.message || "Failed to create");

    return result; // Return the entire result, not result.data
  } catch (error) {
    console.error("Error creating connection:", error);
    throw error;
  }
}

  async getMobileService(id) {
  try {
    const response = await fetch(`${API_BASE_URL}/mobile-details/connection/${id}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
         'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      },
    });

    const result = await response.json();
    if (!response.ok) throw new Error(result.message || 'Failed to fetch mobile contract');
    
    // Transform the data if needed to match your form structure
    return {
      ...result.data,
      staff_levels: result.data.staff_levels || [], // Ensure arrays exist
      data_plans: result.data.data_plans || []
    };
  } catch (error) {
    console.error('Error fetching mobile contract:', error);
    throw error;
  }
  }
  async updateMobileService(id, data) {
  try {
    const response = await fetch(`${API_BASE_URL}/mobile-details/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
         'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      },
      body: JSON.stringify(data),
    });

    const result = await response.json();
    if (!response.ok) throw new Error(result.message || "Failed to update");

    return result; // Return the entire result
  } catch (error) {
    console.error("Error updating connection:", error);
    throw error;
  }
  } 

}

const mobileService = new MobileService();
export default mobileService;
